import { useTranslation } from 'react-i18next';

import { ApplicantCard } from './ApplicantCard';

import type { BoardCard, LaneKey } from '@/types/board.types';

const LANE_HEADER_COLORS: Record<LaneKey, string> = {
  submitted: 'bg-gray-500',
  videoPending: 'bg-yellow-500',
  videoCompleted: 'bg-blue-500',
  underReview: 'bg-purple-500',
  approved: 'bg-green-500',
  waitlist: 'bg-orange-500',
  rejected: 'bg-red-500',
};

interface KanbanLaneProps {
  laneKey: LaneKey;
  cards: BoardCard[];
  onCardClick: (id: string) => void;
}

export function KanbanLane({ laneKey, cards, onCardClick }: KanbanLaneProps) {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col min-w-[280px] max-w-[320px] bg-gray-50 rounded-xl'>
      {/* Header */}
      <div className='flex items-center gap-2 px-3 py-3'>
        <div className={`h-2.5 w-2.5 rounded-full ${LANE_HEADER_COLORS[laneKey]}`} />
        <h3 className='text-sm font-semibold text-gray-700'>{t(`board.lanes.${laneKey}`)}</h3>
        <span className='ml-auto inline-flex items-center justify-center rounded-full bg-gray-200 px-2 py-0.5 text-xs font-medium text-gray-600'>
          {cards.length}
        </span>
      </div>

      {/* Card list */}
      <div className='flex-1 overflow-y-auto px-2 pb-2 space-y-2' style={{ maxHeight: 'calc(100vh - 220px)' }}>
        {cards.map((card) => (
          <ApplicantCard key={card.id} card={card} onClick={onCardClick} />
        ))}
      </div>
    </div>
  );
}
